// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-Banner {
  border-radius: 4px;
}
.n-Banner--type-info {
  background-color: var(--color-info-background-base);
}
.n-Banner--type-warning {
  background-color: var(--color-warning-background-base);
}
.n-Banner--type-error {
  background-color: var(--color-error-background-base);
}
.n-Banner--type-success {
  background-color: var(--color-success-background-base);
}
.n-Banner__icon--size-small {
  font-size: 12px;
}
.n-Banner__icon--size-normal {
  font-size: 16px;
}
.n-Banner__icon--size-jumbo {
  font-size: 24px;
}
.n-Banner__icon--type-info {
  color: var(--color-info-content-base);
}
.n-Banner__icon--type-warning {
  color: var(--color-warning-content-base);
}
.n-Banner__icon--type-error {
  color: var(--color-error-content-base);
}
.n-Banner__icon--type-success {
  color: var(--color-success-content-base);
}
.n-Banner__content--size-small {
  font-size: 12px;
}
.n-Banner__content--size-normal {
  font-size: 14px;
}
.n-Banner__content--size-jumbo {
  font-size: 16px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/banner/Banner.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AANA;EDsBI,kBAAA;ACbJ;AALI;EAAY,mDAAA;AAQhB;AAPI;EAAY,sDAAA;AAUhB;AATI;EAAY,oDAAA;AAYhB;AAXI;EAAY,sDAAA;AAchB;AARM;EAAW,eAAA;AAWjB;AAVM;EAAW,eAAA;AAajB;AAZM;EAAW,eAAA;AAejB;AAXM;EAAY,qCAAA;AAclB;AAbM;EAAY,wCAAA;AAgBlB;AAfM;EAAY,sCAAA;AAkBlB;AAjBM;EAAY,wCAAA;AAoBlB;AAdM;EAAW,eAAA;AAiBjB;AAhBM;EAAW,eAAA;AAmBjB;AAlBM;EACE,eAAA;EACA,kBAAA;AAoBR","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n\n.n-Banner {\n  #venusUI.withBorderRadius();\n\n  &--type {\n    &-info    { background-color: var(--color-info-background-base); }\n    &-warning { background-color: var(--color-warning-background-base); }\n    &-error   { background-color: var(--color-error-background-base); }\n    &-success { background-color: var(--color-success-background-base); }\n  }\n\n\n  &__icon {\n    &--size {\n      &-small  { font-size: @fontSize-xs;}\n      &-normal { font-size: @fontSize-base;}\n      &-jumbo  { font-size: @fontSize-xl;}\n    }\n\n    &--type {\n      &-info    { color: var(--color-info-content-base); }\n      &-warning { color: var(--color-warning-content-base); }\n      &-error   { color: var(--color-error-content-base); }\n      &-success { color: var(--color-success-content-base); }\n    }\n  }\n\n  &__content {\n    &--size {\n      &-small  { font-size: @fontSize-xs;}\n      &-normal { font-size: @fontSize-sm;}\n      &-jumbo  {\n        font-size: @fontSize-base;\n        text-align: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
